/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppSubscriptionsService {
    /**
     * Get available subscription plans
     * Returns active subscription plans with pricing from RevenueCat (when configured) and plan config from DB. Excludes admin-only fields (MRR, ARR, subscriber counts).
     * @returns any Plans fetched successfully
     * @throws ApiError
     */
    public static expertSubscriptionsControllerGetPlansV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/subscriptions/plans',
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Get available add-on boosts
     * Returns active add-ons available for purchase. Excludes admin-only fields (total purchases, revenue).
     * @returns any Add-ons fetched successfully
     * @throws ApiError
     */
    public static expertSubscriptionsControllerGetAddonsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/subscriptions/addons',
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Get current expert subscription and add-on history
     * Returns the expert's current active subscription, active add-ons with remaining days, and previous/expired subscriptions and add-ons.
     * @returns any My subscriptions fetched successfully
     * @throws ApiError
     */
    public static expertSubscriptionsControllerGetMySubscriptionsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/subscriptions/my-subscriptions',
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                404: `Expert profile not found`,
            },
        });
    }
}
